import { Directive, HostListener } from '@angular/core'
import { NgControl } from '@angular/forms'

@Directive({
  selector: '[decimalInput]',
  standalone: true,
})
export class DecimalInputDirective {
  constructor(private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement
    const formatted = this.formatCurrency(input.value)
    this.ngControl.control?.setValue(formatted, { emitEvent: false })
  }

  private formatCurrency(value: string): string {
    let onlyNumbers = value.replace(/\D/g, '')

    while (onlyNumbers.length < 3) {
      onlyNumbers = '0' + onlyNumbers
    }

    const integerPart = onlyNumbers.slice(0, -2)
    const decimalPart = onlyNumbers.slice(-2)

    const integerWithSeparator = parseInt(integerPart, 10).toLocaleString(
      'pt-BR',
    )

    return `${integerWithSeparator},${decimalPart}`
  }
}
